import React, { useEffect, useState } from 'react';
import Counter from '../../components/ui/Counter';
import SearchBar from '../../components/ui/SearchBar';
import AddContact from './AddContact';
import AddToListButton from './AddToListButton';
import ColumnsFilter from './ColumnsFilter';
import styles from './Contacts.module.scss';
import CreateListButton from './CreateListButton';
import Filters from './Filters';
import { useContactsParams } from './useContactsParams';

const Header = ({ contactCount, selection, onAddToList }) => {
  const { params, updateParam } = useContactsParams();
  const [search, setSearch] = useState(params.search || '');
  const hasSelection = selection.length > 0;

  useEffect(() => {
    const handler = setTimeout(() => {
      updateParam('page', 1);
      updateParam('search', search);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [search, updateParam]);

  return (
    <div className={`${styles.header} ${hasSelection ? styles.selection : ''}`}>
      <div className={styles.number_selected}>{selection.length} Selected</div>
      <AddToListButton contacts={selection} onAdd={onAddToList} />
      <Counter
        count={contactCount}
        page={params.page}
        limit={params.limit}
        wrapperClassName={styles.counter}
      />
      <SearchBar
        value={search}
        handleSearch={(val) => setSearch(val)}
        placeholder="Search contacts..."
        className={styles.search}
      />

      <Filters />

      <ColumnsFilter />

      <div className={styles.spacer} />

      {(params.filters !== undefined ||
        (params.status && params.status !== 'all')) && <CreateListButton />}

      <AddContact />
    </div>
  );
};

export default Header;
